<template>
<svg width="18px" height="4px" viewBox="0 0 18 4" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
    <!-- Generator: Sketch 59 (86127) - https://sketch.com -->
    <title>icon</title>
    <desc>Created with Sketch.</desc>
    <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="huntflow-elixir-buttons-great" transform="translate(-108.000000, -353.000000)" fill="#151319">
            <g id="Group" transform="translate(93.000000, 327.000000)">
                <g id="Group-20-Copy-4" transform="translate(0.000000, 13.000000)">
                    <path d="M17,13 C18.1045695,13 19,13.8954305 19,15 C19,16.1045695 18.1045695,17 17,17 C15.8954305,17 15,16.1045695 15,15 C15,13.8954305 15.8954305,13 17,13 Z M24,13 C25.1045695,13 26,13.8954305 26,15 C26,16.1045695 25.1045695,17 24,17 C22.8954305,17 22,16.1045695 22,15 C22,13.8954305 22.8954305,13 24,13 Z M31,13 C32.1045695,13 33,13.8954305 33,15 C33,16.1045695 32.1045695,17 31,17 C29.8954305,17 29,16.1045695 29,15 C29,13.8954305 29.8954305,13 31,13 Z" id="icon"></path>
                </g>
            </g>
        </g>
    </g>
</svg>

</template>